export default {
    courses: {
        list: null,
        single: null
    },
    
    materials: {
        list: null,
        single: null
    },
};